import { createAction } from 'redux-act';

export const changeSort = createAction('Change Table Sort');
export const changePage = createAction('Change Table Page');
export const changeRowsPerPage = createAction('Change Table Rows Per Page');
export const changeFilters = createAction('Change Table Filters');
export const changeSearch = createAction('Change Table Search');
